









import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class CopyText extends Vue {
    @Prop() value!: string

    copy() {
        // @ts-ignore
        const copytext: HTMLInputElement = this.$refs.copytext
        copytext.select()
        copytext.setSelectionRange(0, 99999)
        document.execCommand('copy')
        this.$store.dispatch('Notifications/add', {
            title: 'Copied',
            message: 'Copied to clipoard.',
        })
    }
}
